import { styled, Typography } from 'shared/Houston';

export const Image = styled.img`
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.border.radius.xs};
`;

export const PositionLabel = styled(Typography)`
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const Box = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.medium};
`;

export const Price = styled(Typography)`
  color: ${({ theme }) => theme.feedbackColor.positive.dark};
`;

export const ProductInfoContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.inline.xxxs};
`;

export const ProductDetails = styled.div``;

export const ProductTitle = styled.p`
  word-break: break-word;
`;
